const PlayerNameStacking = {
    PLAYER_NAME_STACKING_SET_DATA_FROM_STORAGE: 'PLAYER_NAME_STACKING_SET_DATA_FROM_STORAGE',
    PLAYER_NAME_STACKING_SET_IS_USED: 'PLAYER_NAME_STACKING_SET_IS_USED',
    PLAYER_NAME_STACKING_ADD_ITEM: 'PLAYER_NAME_STACKING_ADD_ITEM',
    PLAYER_NAME_STACKING_REMOVE_ITEM: 'PLAYER_NAME_STACKING_REMOVE_ITEM',
};

export default PlayerNameStacking;
